export enum AdapterTypeEnum {
  '2D' = '2D',
  '3D' = '3D',
}